<template>

    <b-container style="flex: available">
        <b-container style="margin-top: 25px">
            <p> Thank you for submitting your information. You will be receiving an email shortly about next steps
              to become Napa Green or Beyond Green certified. Our team looks forward to working with you. </p>
        </b-container>
    </b-container>


</template>
<script>
    export default {
        data() {
            return {}
        },
        methods: {}
    }
</script>
